import { styled } from '@mui/material/styles';

export const ActionsFooter = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'flex-end'
}));

export const Content = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column'
}));

export const Description = styled('p')(({ theme }) => ({
  marginTop: theme.spacing(3),
  '& em': {
    color: theme.color?.primary?.main || theme.palette.primary.main,
    fontWeight: theme.fontWeight?.bold || 700,
    fontStyle: 'normal'
  }
}));

export const Summary = styled('div')(() => ({
  textTransform: 'uppercase'
}));

export const Title = styled('div')(({ theme }) => ({
  fontSize: theme.fontSize?.xsmall || '12px',
  marginBottom: theme.spacing(1)
}));

export const Value = styled('div')(({ theme }) => ({
  color: theme.color?.secondary?.main || theme.palette.secondary.main || '#FFA800', // fallback
  fontSize: theme.fontSize?.large || '20px'
}));
